import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { Office } from '../store/office/office.state'
import { eps } from './url.service'

@Injectable({
  providedIn: 'root'
})
export class OfficeService {
  private apiUrl = eps.company.officeApi

  constructor(private http: HttpClient) {}

  getOffices(
    params: string | null,
    page: number | null | undefined,
    limit: number | null | undefined
  ): Observable<{ totalCount: number; offices: Office[] }> {
    const url = params
      ? `${this.apiUrl}?${params}&page=${page}&limit=${limit}`
      : `${this.apiUrl}?page=${page}&limit=${limit}`
    return this.http.get<{ totalCount: number; offices: Office[] }>(url)
  }

  createOffice(office: { officeName: string; businessId: string }): Observable<Office> {
    return this.http.post<Office>(`${this.apiUrl}`, office)
  }

  updateOffice(office: {
    id: string
    officeName: string
    address: string
    cityId: number
    zipCode: string
  }): Observable<Office> {
    return this.http.put<Office>(`${this.apiUrl}/${office.id}`, office)
  }

  getOfficeById(id: string): Observable<Office> {
    return this.http.get<Office>(`${this.apiUrl}/${id}`)
  }
}
